module.exports = __webpack_public_path__ + "media/images/favicons/google-144x144-894362d40aa452517a60497da960e1ae.png";